import { Component, State, Prop, h} from '@stencil/core';

@Component({
  tag: 'fdi-container',
  styleUrl: 'fdi-container.scss',
  shadow: true,
})

export class FDIContainer {

  @Prop() __settings: any;

  @State() settings: any = {
    title: '',
    expandText: '&#9660; ',
    collapseText: '&#9650; ',
    allowCollapse: true,
    initializeCollapsed: false,
    showMenu: true,
    style: {
      titleContainer:{
        textAlign: 'center'
      },
      container: {},
      menu: {},
      content: {
        overflow: 'hidden',
      },
    },
    meta: {}
  };
  @State() collapsed: boolean = false;

  componentWillLoad(){
    let settings = this.__settings;

    if ( typeof settings === 'string' ){
      settings = JSON.parse( this.__settings );
    }

    this.settings = { ...this.settings, ...settings };
    if ( this.settings.initializeCollapsed ) this.collapsed = true;
    if ( !this.settings.allowCollapse ) this.collapsed = false;
  }

  render() {

    let contentHeight = `${ this.collapsed ? 0 : ( this.settings.style.content.height || 'auto' ) }`;
    let expandAndCollapseText = this.collapsed ? this.settings.expandText : this.settings.collapseText;
    return (
      <div
        class={ 'fdi wc container' }
        style={ this.settings.style.container }
      >
        {
          <div class={ 'titleContainer' } style={ this.settings.style.titleContainer }>
            <h1>
              {
                this.settings.allowCollapse &&
                <span class={ 'collapseTrigger' } onClick={ () => { this.collapsed = !this.collapsed } } innerHTML={ expandAndCollapseText }> </span>
              }
              <span innerHTML={ this.settings.title ? this.settings.title : '' }> </span>
            </h1>
          </div>
        }
        { this.settings.showMenu &&
          <div class={ 'menu' } style={ this.settings.style.menu }>
            <ul>

            </ul>
          </div>
        }
        <div class={ 'content' } style={ { ...this.settings.style.content, ...{ height: contentHeight } } }>
          <slot />
        </div>
      </div>
    );
  }
}
